import { render } from "./ThirdPartyNoticesPage.vue?vue&type=template&id=715ad0ad&scoped=true"
import script from "./ThirdPartyNoticesPage.vue?vue&type=script&lang=js"
export * from "./ThirdPartyNoticesPage.vue?vue&type=script&lang=js"

import "./ThirdPartyNoticesPage.vue?vue&type=style&index=0&id=715ad0ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715ad0ad"]])

export default __exports__